import * as React from "react";
const SvgFiRrHatCowboy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hat-cowboy_svg__a)">
      <path
        fill="#062147"
        d="M24 1a1 1 0 0 0-1.999-.004s-.009 2.069-.009 3.604c0 1.473-.145 2.85-.407 4.155C17.034 5.162 10.153.413 7.966 2.601c-.979.979-.979 2.305-.978 3.274 0 .346 0 .925-.069 1.044-.136.086-.702.082-1.041.081-.96-.004-2.276-.015-3.258.967-2.187 2.187 2.552 9.068 6.137 13.618a21 21 0 0 1-4.157.407c-1.535 0-3.604.009-3.604.009a1 1 0 0 0 .004 2h.004s2.064-.008 3.596-.008c5.635 0 10.326-1.833 13.942-5.449s5.449-8.307 5.449-13.942c0-1.531.009-3.596.009-3.596V1m-6.872 16.128a15.9 15.9 0 0 1-6.262 3.891 77 77 0 0 1-1.323-1.699 14.34 14.34 0 0 0 6.128-3.65 14.5 14.5 0 0 0 2.725-3.755 1 1 0 0 0-1.789-.896 12.5 12.5 0 0 1-2.35 3.236 12.4 12.4 0 0 1-5.98 3.333C5.46 13.62 3.623 10.165 4.036 9.379c.364-.363.966-.386 1.831-.381.837.006 1.789.012 2.458-.657.667-.667.666-1.624.666-2.469 0-.753 0-1.465.375-1.845 1.021-.531 6.415 2.633 11.656 6.837a15.9 15.9 0 0 1-3.891 6.262z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hat-cowboy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHatCowboy;
